export default "__VITE_ASSET__XYEAbQ4q__"